module.exports = __webpack_public_path__ + "img/1440.e535d8f2.jpg";